import { type Nullable } from '@vitvio/helpers';
import { useLazyLoadQuery } from 'react-relay';
import { useDemoFunctionalityContext } from '@vitvio/demo-functionality';
import type { JobsLoaderQuery } from '../graphql/__generated__/JobsLoaderQuery.graphql';
import { jobsLoaderQuery } from '../graphql';

/** When hospitalId is null/undefined, the query is skipped via @skip and null is returned (no network request). */
export function useHospital(hospitalId: Nullable<string>) {
  const { globalReloadKey, numberOfOperatingRooms } = useDemoFunctionalityContext();

  const data = useLazyLoadQuery<JobsLoaderQuery>(
    jobsLoaderQuery,
    {
      skip: !hospitalId,
      hospitalId: hospitalId ?? '00000000-0000-0000-0000-000000000000',
      numberOfOperatingRooms,
    },
    { fetchPolicy: 'store-and-network', fetchKey: globalReloadKey },
  );

  return data?.hospital ?? null;
}
